const entorno = () => {
  if (!!process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  } else {
    return "test";
  }
};

const BaseUri = {
  test: "https://localhost:8080",
  // * region [ rgba (10,80,10,0.3)] Modificar
  development: "https://www.colmena.ugto.mx/EncuestasUG",
  production: "https://intraug.ugto.mx/EncuestasUG",
  // * endregion
};

export const baseUri = BaseUri[entorno()];
